import { reactive, toRefs } from "vue"
import type { ToRefs } from "vue"
//@ts-ignore
import {SnackbarProps} from "@customTypes/SnackbarTypes";

interface UsableBaseSnackbarState {
    showBaseSnackbar: boolean;
    baseSnackbarProps: SnackbarProps
}

interface UsableBaseSnackbar extends ToRefs<UsableBaseSnackbarState>{
    handleShowSnackbar: (props: SnackbarProps) => void;
}

export function useBaseSnackbar(): UsableBaseSnackbar{
    const state: UsableBaseSnackbarState = reactive({
        showBaseSnackbar: false,
        baseSnackbarProps: {
            title: "",
            body: "",
            type: "",
            cb: null
        }
    })

    const handleShowSnackbar = (props: SnackbarProps): void => {
        state.baseSnackbarProps.title = props.title || "";
        state.baseSnackbarProps.body = props.body;
        state.baseSnackbarProps.type = props.type;
        state.baseSnackbarProps.cb = props.cb || null;
        state.showBaseSnackbar = true;
    }

    return {
        ...toRefs(state),
        handleShowSnackbar
    }
}